export default "__VITE_ASSET__Dht4T1i___"